module.exports = __webpack_public_path__ + "static/img/centerBack.5e79bd93.svg";